import { getCardBrand } from './get-card-brand';
import { getCardNumberMaxLengthByBrand } from './get-card-number-max-length-by-brand';
export const formatCardNumber = (cardNumber) => {
    var _a, _b;
    const cardBrand = getCardBrand(cardNumber);
    const maxLength = getCardNumberMaxLengthByBrand(cardBrand);
    let formattedCardNumber = (_b = (_a = cardNumber
        .replace(/\s/g, '')
        .replace(/\D/g, '' // To allow only digits
    )
        .match(/.{1,4}/g)) === null || _a === void 0 ? void 0 : _a.join(' ')) !== null && _b !== void 0 ? _b : '';
    formattedCardNumber = formattedCardNumber.substr(0, maxLength);
    return formattedCardNumber;
};
//# sourceMappingURL=format-card-number.js.map